// extracted by mini-css-extract-plugin
module.exports = {"blogPostSocialShare":"style_blogPostSocialShare__Ysxc5","shareButton":"style_shareButton__ZEqi3","tooltip":"style_tooltip__j5P42 g-type-body-small"};